/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Mfa_Not_EnrolledInputs */

const en_error_mfa_not_enrolled = /** @type {(inputs: Error_Mfa_Not_EnrolledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The user has no second factor to remove.`)
};

/**
* | output |
* | --- |
* | "The user has no second factor to remove." |
*
* @param {Error_Mfa_Not_EnrolledInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_mfa_not_enrolled = /** @type {((inputs?: Error_Mfa_Not_EnrolledInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Mfa_Not_EnrolledInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_mfa_not_enrolled(inputs)
});